<template>
  <div>
    <h2>Manage speech to text services</h2>
    <p>
      Create, edit or delete speech to text services.
    </p>
    <div>
      <div>
        <ul v-if="!getSttServicesPending && sttServices.length" class="services-list">
          <li v-for="sttService in sttServices" :key="sttService.id" class="services-list-item">
            <div>
              {{ sttService.name }}
            </div>
            <div>
              {{ sttService.sttProvider }}
            </div>
            <div>
              {{ sttService.description }}
            </div>
            <div class="action-wrapper">
              <p-button class="action-icon" variant="text" color="primary" @click.stop="edit(sttService)">&#9998;</p-button>
            </div>
          </li>
        </ul>
      </div>
      <p-button color="primary" type="submit" @click.stop="create">Register service</p-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Button from '@/components/common/Button';

export default {
  components: {
    'p-button': Button
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      getSttServicesPending: s => s.nlp.getSttServicesPending,
      sttServices: s => s.nlp.sttServices || []
    })
  },
  async created() {
    await Promise.all([this.$store.dispatch('nlp/getSttServices')]);
  },
  methods: {
    async create() {
      this.$router.push({ path: `/sttservices` });
    },
    async edit(sttService) {
      this.$router.push({ path: `/sttservices/${sttService.id}` });
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  color: var(--theme-on-surface);
  font-size: 1.5rem;
  font-weight: 700;
}

h2 {
  color: var(--theme-on-surface-dark);

  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}
h3 {
  color: var(--theme-on-surface-dark);

  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

p {
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}

.services-list {
  width: max-content;
  padding-bottom: 5px;
  min-width: 758px;

  .services-list-item {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 30px;
    border-top: 1px solid var(--theme-highlight);

    > div {
      border-left: 1px solid var(--theme-highlight);
      padding: 0.35rem 0.5rem;
      font-size: 0.85rem;

      &:last-child {
        border-right: 1px solid var(--theme-highlight);
      }

      &.status {
        font-weight: bold;
        justify-self: center;

        &.in-progress {
          color: #f9a825;
        }
        &.failed {
          color: #da2d2d;
        }
        &.completed {
          color: #2e815b;
        }
      }
    }

    .action-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .action-icon {
      font-weight: 700;
      color: var(--theme-primary);
      cursor: pointer;
      justify-self: center;
    }

    &:last-child {
      border-bottom: 1px solid var(--theme-highlight);
    }
  }

  .organizations-list {
    display: flex;
    width: 300px;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    gap: 5px;
  }

  .organizations-list li {
    border-radius: 2px;
    background: var(--theme-primary);
    padding: 0.25rem;
  }
}
</style>
